import { Loader } from '../../Loader';

export const FullScreenLoader = () => {
  return (
    <div>
      <Loader />
    </div>
  );
};
